

// Production configuration


// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseProductionConfig = {
  apiKey: 'AIzaSyDhKqvdHu-6HxfXj3Zu7hz2MwFcjFbY-18',
  authDomain: 'ecoin369.firebaseapp.com',
  databaseURL: 'https://ecoin369-default-rtdb.firebaseio.com',
  projectId: 'ecoin369',
  storageBucket: 'ecoin369.appspot.com',
  messagingSenderId: '160602156822',
  appId: '1:160602156822:web:07281c502ff6e748a46a37',
  measurementId: 'G-5WW6NEDC1Y'
}


export {
  firebaseProductionConfig
}

